import './FeaturedInCompaniesCarousel.scss';

import { FeaturedCompany } from '@travelwin/cms/types';

import { ImageMedia } from '@/components/ImageMedia';
import { RichText } from '@/components/RichText';

import EmblaCarousel from '../Carousel/EmblaCarousel';

const className = 'c-FeaturedInCompaniesCarousel';

type FeaturedInCompanyItem = NonNullable<
  NonNullable<FeaturedCompany['featuredInCompanies']>[number]
>;

export const FeaturedInCompaniesCarousel = ({
  featuredCompaniesContent,
}: {
  featuredCompaniesContent?: FeaturedCompany | null;
}) => {
  if (!featuredCompaniesContent) return null;
  //For infinite loop, you need enough slides.
  //If the number of slides is less than 16, we duplicate the slides to make it 16.
  // 16 is arbitrary number but trying to account for larger screens.
  const determineSlidesToDisplay = () => {
    let duplicatedSlides;
    if ((featuredCompaniesContent?.featuredInCompanies?.length ?? 0) < 16) {
      let slides = featuredCompaniesContent.featuredInCompanies || [];
      while (slides.length < 16) {
        slides = [...slides, ...slides];
      }
      duplicatedSlides = {
        ...featuredCompaniesContent,
        featuredInCompanies: slides,
      };
      return duplicatedSlides;
    } else {
      return featuredCompaniesContent;
    }
  };

  const { featuredInCompanies, featuredInCompaniesHeader } =
    determineSlidesToDisplay();

  return (
    <div className={className}>
      <div className={`${className}__header`}>{featuredInCompaniesHeader}</div>

      <EmblaCarousel
        options={{ loop: true, align: 'start' }}
        useAutoScroll={true}
      >
        {featuredInCompanies?.map((company: FeaturedInCompanyItem) => (
          <div key={company.id} className={`${className}__featured-container`}>
            <div className={`${className}__featured-company-logo`}>
              <ImageMedia
                media={company.companyLogoUpload}
                sizes="20vw"
                loading="lazy"
              />
            </div>
            <div className={`${className}__featured-company-text`}>
              <RichText content={company.bodyText} />
            </div>
          </div>
        ))}
      </EmblaCarousel>
    </div>
  );
};

export default FeaturedInCompaniesCarousel;
